
(function ($) {
    
    var initSearchPanel = function (){
    
        $(document).on('change', '#numofroom', function () {
            var numofroom = $(this).val();
            if (numofroom > 1) {
                hideElement('.numofadult');
                hideElement('.numofchild');
                showElement('.note');

            } else {
                showElement('.numofadult');
                showElement('.numofchild');
                hideElement('.note');
            }       
        });

        function showElement(id) {
            $(id).removeClass('hide');
        }

        function hideElement(id) {
            $(id).addClass('hide');
        }
    };
    
    if (window.InitSearchPanel === undefined) {
        window.InitSearchPanel = initSearchPanel;
    }
    window.InitSearchPanel();
    
})(jQuery);
